import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import styles from "./Img.module.scss";

const Img = ({
	className,
	wrapperClassName,
	src,
	source,
	alt,
	title,
	autoResponsive,
	...props
}) => {
	if (src) {
		return (
			<img
				className={cx(autoResponsive && styles.responsive, wrapperClassName)}
				src={src}
				alt={alt}
				title={title}
				{...props}
			/>
		);
	}

	if (source) {
		return (
			<picture {...props}>
				<source srcSet={source.srcSet} sizes={source.sizes} />
				<img
					className={cx(autoResponsive && styles.responsive, wrapperClassName)}
					src={source.src}
					srcSet={source.srcSet}
					sizes={source.sizes}
					alt={alt}
					title={title}
					{...props}
				/>
			</picture>
		);
	}

	console.error("Img requires either src or source as a prop");

	return <></>;
};

Img.propTypes = {
	className: PropTypes.string,
	wrapperClassName: PropTypes.string,
	/**
	 * If supplied - it will output just a simple image using `<img />`
	 */
	src: PropTypes.string,
	/**
	 * If supplied - it will output a responsive image using `<picture />`
	 */
	source: PropTypes.shape({
		src: PropTypes.string,
		srcSet: PropTypes.string,
		sizes: PropTypes.string,
	}),
	alt: PropTypes.string.isRequired,
	title: PropTypes.string,
	/**
	 * By default, it is set to `true`, make sure import the css
	 */
	autoResponsive: PropTypes.bool,
};

Img.defaultProps = {
	className: undefined,
	wrapperClassName: undefined,
	src: undefined,
	source: undefined,
	title: undefined,
	autoResponsive: true,
};

export default Img;
export { Img };
